<mat-chip class="badge-status-{{status.toLowerCase()}} flat h-[52px]">
  <mat-icon *ngIf="showIcon" matChipAvatar>warning</mat-icon>
  <div class="text-[28px] font-normal">{{ 'yardOperations.taskStatus.' + status | translate }}</div>
</mat-chip>
